import React from 'react';
import Link from '../Link';
import RightChevron from '../RightChevron';
import styles from './ActionButton.module.scss';

/**
 * A button with a tabbed or primary/secondary look, with or without a next indicator.
 *
 * @param {Object} props
 * @param {string} [props.className] - Additional CSS class name.
 * @param {*} props.children - Button content.
 * @param {string} [props.href] - Link href.
 * @param {function} [props.onClick] - Click callback.
 * @param {boolean} [props.tab=false] - Whether button is tabbed.
 * @param {boolean} [props.next=false] - Whether button has a next indicator.
 * @param {boolean} [props.primary=false] - Whether button is primary.
 * @param {boolean} [props.secondary=false] - Whether button is secondary.
 * @param {boolean} [props.small=false] - Whether button is small.
 * @param {React.Component} [props.icon] - Icon
 * @param {Object} [props.style]
 */
function ActionButton(props) {
    const {
            className = '',
            children,
            href,
            onClick,
            tab = false,
            next = false,
            primary = false,
            primaryText = false,
            secondary = false,
            secondaryText = false,
            small = false,
            icon,
            style,
            color,
            nextColor,
        } = props,
        fillBackground = (primary || secondary) && !tab;

    return (
        <Link
            className={[
                styles.ActionButton,
                className,
                primary ? styles.primary : '',
                secondary ? styles.secondary : '',
                primaryText ? styles.primaryText : '',
                secondaryText ? styles.secondaryText : '',
                fillBackground ? styles.lightColors : '',
                tab ? styles.tabbed : '',
                small ? styles.small : '',
            ].join(' ')}
            href={href}
            onClick={onClick}
            style={{
                backgroundColor: fillBackground ? color : undefined,
                ...style,
            }}>
            {icon ? icon : <div className={styles.tab} style={{ backgroundColor: color }} />}
            <div className={styles.content}>{children}</div>
            {next ? (
                <div className={styles.next}>
                    <RightChevron color={nextColor || (fillBackground ? '#fff' : undefined)} />
                </div>
            ) : null}
        </Link>
    );
}

export default ActionButton;
